"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopoverBodyLiteIcons = exports.ColorPickerModes = exports.KeyTypes = exports.PopoverType = exports.PopoverBodyMode = void 0;
var PopoverBodyMode = {
  PREVIEW: 'preview',
  EDIT: 'edit'
};
exports.PopoverBodyMode = PopoverBodyMode;
var PopoverType = {
  INSERT: 'insert',
  EDIT: 'edit'
};
exports.PopoverType = PopoverType;
var KeyTypes = {
  ESCAPE: 'Escape',
  ENTER: 'Enter'
};
exports.KeyTypes = KeyTypes;
var ColorPickerModes = {
  ADVANCED: 'advanced',
  SIMPLE: 'simple'
};
exports.ColorPickerModes = ColorPickerModes;
var PopoverBodyLiteIcons = {
  EDIT: 'edit',
  REPLACE: 'replace',
  REMOVE: 'delete',
  UNLINK: 'unlink'
};
exports.PopoverBodyLiteIcons = PopoverBodyLiteIcons;